// Fallback used until the configurable value has been fetched from
// GET /settings/promotion_min_funding_goal (admin-editable, see
// services/SettingsService.js and scenes/AdminSettings).
export const PROMOTION_MIN_FUNDING_GOAL = 5000;

// During project creation, final_goal is staged in sessionStorage until the
// project actually exists (see FundingGoal.js), so project.fundingTarget
// isn't populated yet even though the user already entered a goal.
const getStagedFinalGoal = () => {
  try {
    const value = sessionStorage.getItem('fundingData');
    return value ? JSON.parse(value).final_goal : undefined;
  } catch {
    return undefined;
  }
};

export const isPromotionEligible = (
  project,
  minFundingGoal = PROMOTION_MIN_FUNDING_GOAL
) => {
  const finalGoal = Number(
    project?.fundingTarget?.final_goal ?? getStagedFinalGoal()
  );
  return Number.isFinite(finalGoal) && finalGoal >= Number(minFundingGoal);
};
